import request from '@/utils/request'
// import qs from 'qs'

// 分页查看所有字典
export const pageList = (getData) => {
  return request({
    url: '/back/dict/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    // data: postData
    params: getData
  })
}
// 根据id查询
export const getById = (getData) => {
  return request({
    url: '/back/dict/getById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 根据id删除
export const deleteById = (getData) => {
  return request({
    url: '/back/dict/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 根据id进行更新
export const updateById = (postData) => {
  return request({
    url: '/back/dict/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 新增字典
export const addDict = (postData) => {
  return request({
    url: '/back/dict/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 设备及模板类型字典
export const queryEquipment = (type) => {
  return request({
    url: '/back/dict/queryListByTypes',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: type
  })
}
